const zh = {
    shareTitle: '钱包科普',
    shareDesc: 'TokenPocket带你开启区块链征程',
    testUrl: 'https://www.wenjuan.ltd/s/RzeAz2W/#'
};

export default zh;
